import Image, { StaticImageData } from './Image'

type PropTypes = {
  image: StaticImageData
  title: string
  altText: string
}

const ImageHeader =  ({
  image,
  title,
  altText = 'Beautiful blue sea bay with white walled building',
}: PropTypes) => {
  return <>
    <div className="relative flex h-[375px] lg:h-[790px]">
      <Image
        src={image}
        alt={altText}
        className="absolute inset-0 object-cover"
        layout="fill"
        priority
      />
      <h1 className="whitespace-pre-wrap absolute max-w-[1070px] px-10 mx-auto left-0 right-0 bottom-[44%] text-center text-white font-bold font-serif text-32 md:text-42 lg:text-48 xl:text-60 leading-title tracking-title drop-shadow-title">
        { title }
      </h1>
    </div>
    <div className="flex flex-col lg:flex-row gap-x-50 lg:gap-x-75 xl:gap-x-90 justify-between w-full max-w-[1050px] lg:mx-auto gap-y-20 relative md:static -mt-20 md:mt-10 bg-white rounded-t-20 pt-50 h-[50px] lg:hidden">
    </div>
  </>
}

export default ImageHeader
